/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React from "react";
import { ScrollArea } from "../../scrollarea/components/ScrollArea";
import { getBodyGutter } from "../styled/modalTheme";
/**
 * ModalBody is a component intended to be composed inside a Modal. It is responsible for:
 * - Rendering the main content area (aka the body) of a modal
 * - Providing a scrolling context for the modal body
 * - Locking browser scroll inside the modal, so the page doesn't scroll behind it
 * - Rendering an affordance that there's more content below the fold
 */
export var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
    scrollContainerClientId = _ref.scrollContainerClientId,
    className = _ref.className;
  var themeMode = useCombinedThemeMode();
  return jsx(ScrollArea, {
    className: className,
    clientId: scrollContainerClientId,
    gutter: getBodyGutter({
      themeMode: themeMode
    }),
    lockPageScroll: true
  }, children);
};
//# sourceMappingURL=ModalBody.js.map